<template>
  <div class="sentence-word">
    <PinyinPreview class="pinyin-preview" :text="nativeModel.text" :pinyin="nativeModel.pinyin" @click.native="handleClickPreview($event)"></PinyinPreview>
    <el-button class="sentence-word-reset" type="primary" icon="el-icon-refresh" @click="handleResetWords">重置分词</el-button>
    <el-table
      :data="words"
      border
      style="width: 100%; margin-top:10px;"
      :row-class-name="tableRowClassName"
      :default-sort = "{prop: 'status', order: 'ascending'}"
    >
      <el-table-column type="index" width="50"></el-table-column>
      <el-table-column prop="word" label="关键字" width="120"></el-table-column>
      <el-table-column width="120" label="目标内容">
        <template #default="{row}">
          <span v-if="row.target" :class="row.target.text !== row.word ? 'text-danger' : ''">{{row.target.text}}</span>
          <span v-if="row.count>1">({{row.count}})</span>
        </template>
      </el-table-column>
      <el-table-column label="目标类型" width="100">
        <template #default="{row}">
          <span v-if="row.type===1">语法</span>
          <span v-else-if="row.type===2">词汇</span>
          <span v-else>{{row.type}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="target.id" label="目标id" width="100"></el-table-column>
      <el-table-column prop="target.level" label="目标等级" width="100"></el-table-column>
      <el-table-column :prop="'translations.'+item.lang" :label="item.title" v-for="(item, key) in translationColumns" :key="key"></el-table-column>
      <el-table-column fixed="right" width="120">
        <template #header>
          <el-popover placement="bottom" width="130" popper-class="langs-filters">
            <el-checkbox v-model="item.visible" v-for="(item, key) in languages" :key="key" :label="item.lang" style="display:block;">{{item.title}}</el-checkbox>
            <div style="text-align: center; margin: 8px 0 0 0;">
              <el-button size="mini" type="text" @click="checkAllTranslationColumns">全选</el-button>
              <el-button size="mini" type="text" @click="clearTranslationColumns">清除</el-button>
            </div>
            <span class="langs-column" slot="reference"><i class="el-icon-setting"></i> 其他语种</span>
          </el-popover>
        </template>
        <template #default="column">
          <el-button type="text" size="small" class="btn-word-link" @click="$refs.pop.show($event.target, {model: column.row, type: 2})">选词汇</el-button>
          <el-button type="text" size="small" class="btn-word-link" @click="$refs.pop.show($event.target, {model: column.row, type: 1})">选语法</el-button>
        </template>
      </el-table-column>
    </el-table>
    <DynamicPopover popper-class="sentence-word-pop" ref="pop" placement="bottom-end">
      <template #default="{payload}">
        <el-tabs :value="'tab' + payload.type">
          <el-tab-pane label="词汇" name="tab2">
            <WordInlineList class="sentence-word-select" border :selection="payload.model ? payload.model.target_id : 0" :searchs="{search: payload.model ? payload.model.word : null}" @loaded="refeshPopsition">
              <template #operate="word">
                <el-button type="text" size="small" @click="handleLinkTarget(payload, 2, word.row)">关联</el-button>
              </template>
            </WordInlineList>
          </el-tab-pane>
          <el-tab-pane label="语法" name="tab1">
            <GrammarInlineList class="sentence-word-select" border :selection="payload.model ? payload.model.target_id : 0" :searchs="{search: payload.model ? payload.model.word : null}" @loaded="refeshPopsition">
              <template #operate="grammar">
                <el-button type="text" size="small" @click="handleLinkTarget(payload, 1, grammar.row)">关联</el-button>
              </template>
            </GrammarInlineList>
          </el-tab-pane>
        </el-tabs>
      </template>
    </DynamicPopover>
  </div>
</template>

<script>
import PinyinPreview from '@/components/PinyinPreview'
import WordInlineList from '@/components/word/WordInlineList'
import GrammarInlineList from '@/components/grammar/GrammarInlineList'
import DynamicPopover from '@/components/DynamicPopover'

export default {
  name: 'SentenceWord',
  components: {PinyinPreview, WordInlineList, GrammarInlineList, DynamicPopover},
  props: {
    model: null
  },
  watch: {
    model () {
      this.initNativeModel()
      this.fetchWords()
    }
  },
  data () {
    return {
      words: [],
      nativeModel: {},
      languages: [
        {lang: 'en', title: '英文(English)', visible: true},
        {lang: 'ja', title: '日文(日本語)', visible: true},
        {lang: 'ko', title: '韩文(한국어)', visible: true},
        {lang: 'vi', title: '越南(Tiếng Việt)', visible: false},
        {lang: 'th', title: '泰语(ภาษาไทย)', visible: false},
        {lang: 'ru', title: '俄语(Русский)', visible: false},
        {lang: 'es', title: '西班牙语(español)', visible: false},
        {lang: 'ar', title: '阿拉伯语(اللغة العربية)', visible: false},
        {lang: 'fr', title: '法语(Français)', visible: false}
      ]
    }
  },
  computed: {
    translationColumns () {
      return this.languages.filter(n => n.visible)
    }
  },
  mounted () {
    this.initNativeModel()
    this.fetchWords()
  },
  methods: {
    initNativeModel() {
      this.nativeModel = Object.assign({}, this.model)
    },
    tableRowClassName({row, rowIndex}) {
      if (row.status === 0) {
        return 'check-row'
      }
      if (row.type === 1) {
        return 'warning-row'
      }
      return ''
    },
    fetchWords() {
      if (!this.model) {
        this.words = []
        return
      }
      let params = {
        id: this.model.id
      }
      this.$http.get(this.$urls.sentence_word, { params }).then(res => {
        this.words = res.data.map(n => {
          n.translations = {}
          if (n.target && n.target.translations) {
            n.target.translations.forEach(t => {
              n.translations[t.language] = t.text || t.explain
            })
          }
          return n
        }).sort((a, b) => {
          if (a.status < b.status) {
            return -1
          } else if (a.status > b.status) {
            return 1
          } else {
            return a.id - b.id
          }
        })
        this.handleModelHighLink()
      })
    },
    checkAllTranslationColumns () {
      this.languages.forEach(n => n.visible = true)
    },
    clearTranslationColumns () {
      this.languages.forEach(n => n.visible = false)
    },
    handleLinkTarget(payload, type, target) {
      return this.$http.put(this.$urls.sentence_word_update, {
        type,
        target_id: target.id,
        status: 1,
      }, {
        params: { id: payload.model.id }
      }).then(res => {
        if (this.$refs.pop.referenceEle && this.$refs.pop.referenceEle.classList.contains('check-word')) {
          this.$refs.pop.referenceEle.classList.remove('check-word')
        }
        this.$refs.pop.close()
        this.fetchWords()
      })
    },
    refeshPopsition() {
      window.setTimeout(() => {
        this.$refs.pop.refeshPopsition()
      }, 300)
    },
    handleResetWords() {
      this.$confirm('确定要删除当前句子的所有分词并重新生成新的分词吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(res => {
        this.$http.post(this.$urls.sentence_word_reset, {id: this.model.id}, {
          params: {id: this.model.id}
        }).then(() => {
          this.fetchWords()
        })
      })
    },
    handleModelHighLink() {
      let data = this.nativeModel
      if (data) {
        this.words.filter(n => n.status===0 || !n.target).forEach(n => {
          this.setJsonXpath(data, n.xpath, `<span{%20}class="check-word"{%20}data-xpath="${encodeURIComponent(n.xpath)}">{0}</span>`)
        })
      }
    },
    extraJsonXpath(obj, path) {
      let m = /\[(\d+)\]|\./.exec(path)
      if (!m) return {obj, attr: path}
      let attr = path.substr(0, m.index)
      if (!(attr in obj)) return {obj: null, attr: null}
      if (m[1] !== undefined) {
        obj = obj[attr]
        if (obj && obj.length > m[1]) {
          attr = Number.parseInt(m[1])
        } else {
          return {obj: null, attr: null}
        }
      }
      path = path.substr(m.index + m[0].length).replace(/^\./, '')
      return path ? this.extraJsonXpath(obj[attr], path) : {obj, attr}
    },
    setJsonXpath(jsonObj, xPath, val) {
      let parts = xPath.split(':')
      let { obj, attr } = this.extraJsonXpath(jsonObj, parts[0])
      if (obj && attr && attr in obj) {
        let items = obj[attr].split(' ')
        let index = parts.length > 1 ? Number.parseInt(parts[1]) : 0
        items[index] = val.replace('{0}', items[index])
        obj[attr] = items.join(' ')
      }
    },
    handleClickPreview(event) {
      if (event.target && event.target.dataset && event.target.dataset.xpath) {
        let xpath = decodeURIComponent(event.target.dataset.xpath)
        let model = this.words.find(n => n.xpath === xpath)
        this.$refs.pop.show(event.target, {model, type: model.type, showDetail: true})
      }
    }
  }
}
</script>

<style lang="scss">
  .sentence-word {
    .el-table {
      .warning-row {
        background-color: oldlace;
      }
      .check-row {
        background-color: rgb(243, 201, 13);
      }
      tr.hover-row.warning-row > td {
        background-color: oldlace;
      }
      tr.hover-row.check-row > td {
        background-color: rgb(243, 201, 13);
      }
    }
    .check-word, check-word {
      color:#F56C6C;
    }
  }
  .sentence-word-select .search-form {
    margin-bottom: 10px;
  }
  .sentence-word-reset{
    position: absolute;
    right: 20px;
    margin-top: -40px;
  }
  .sentence-word-pop{
    .checked-row{
      background-color: #F5F7FA;
    }
    tr.hover-row.checked-row>td{
      background-color: #F5F7FA;
    }
  }
</style>